
import request from '@/util/http'

import qs from 'qs'

// 办事大厅主题查询
export const getSubjectVoList=()=>request({
    url: '/admin/homeServe/getSubjectVoList',
    method: 'get',
})
// 办事大厅专题查询
export const getTopicVoList=()=>request({
    url: '/admin/homeServe/getTopicVoList',
    method: 'get',
})


// 办事大厅服务查询
export const getServeVoList=(params)=>request({
    url: '/admin/homeServe/getServeVoList',
    method: 'get',
    params
})

// 收藏、取消收藏
export const favorOrRecall=(data)=>request({

    url: '/admin/homeServe/favorOrRecall',
    method: 'post',
    data:qs.stringify(data)
})


// 服务详情
export const getServeDetail=(id)=>request({
    url: `/admin/homeServe/getServe?serve_id=${id}`,
    method: 'get'
})


// 获取服务评价列表
export const serveEvaluateBigVoList=(params)=>request({
    url: `/admin/homeServe/getServeEvaluateBigVoList`,
    method: 'get',
    params
})

// 获取服务评价信息
export const serveEvaluateSmallVo=(params)=>request({
    url: `/admin/homeServe/getServeEvaluateSmallVo`,
    method: 'get',
    params
})


// 获取服务评价类型
export const serveEvaluateTypeVoList=(params)=>request({
    url: `/admin/homeServe/getServeEvaluateTypeVoList`,
    method: 'get',
    params
})



// 获取服务满意度
export const serveSatisfactionVoList=(params)=>request({
    url: `/admin/homeServe/getServeSatisfactionVoList`,
    method: 'get',
    params
})


// 提交服务评价
export const handleServeEvaluate=(params)=>request({
    headers:{
        "Content-Type": "application/json"
    },
    url: `/admin/homeServe/submitServeEvaluate`,
    method: 'post',
    data:JSON.stringify(params)
    })


// 获取制筛选项
export const getCustom=()=>request({
    url: `/admin/homeServe/getCustom`,
    method: 'get',
})


// 定制/取消定制筛选项
export const handlecustomOrRecall=(params)=>request({
    url: `/admin/homeServe/customOrRecall`,
    method: 'post',
    params
})
